/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { RawEvent } from '../../../interface/eventInterface';
import { Tracker } from '../trackers';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: any;
  }
}

export class GTMTrackerForThakyouPage implements Tracker {
  private gtmIDs: string[];

  constructor(gtmIDs: string[]) {
    if (gtmIDs.length === 0) {
      throw new Error('GTMTrackerForThakyouPage requires at least one GTM ID.');
    }
    this.gtmIDs = gtmIDs;
  }

  Init(): void {
    this.injectScript();
  }

  private injectScript() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    this.gtmIDs.forEach(gtmID => {
      (function (w: any, d: any, s: any, l: any, i: any) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', gtmID);
    });

    window.gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    });
  }

  TrackEvent(_event: RawEvent): void {
    this.gtmIDs.forEach(gtmID => {
      const eventName = (() => {
        switch (_event.eventName) {
          case 'ThankYouPageReached':
            return 'thank_you_page_reached';
          default:
            return '';
        }
      })();
      const mapItems = () => {
        return Array.isArray(_event.cart?.LineItems)
          ? _event.cart?.LineItems?.map((item, idx) => ({
              item_name: item?.Name,
              item_id: item?.ProductID,
              item_brand: item?.Brand,
              item_category: item?.Category,
              item_variant: item?.Subtitle,
              price: item?.UnitPrice,
              quantity: item?.Quantity,
              google_business_vertical: 'retail',
              index: idx,
            }))
          : [];
      };
      if (eventName === 'thank_you_page_reached') {
        console.log('thank_you_page_reached event triggered');
        window.dataLayer.push({
          event: eventName,
          timeStamp: _event.cart?.UpdatedAt,
          email: _event.cart?.Email,
          phone: _event.cart?.PhoneNumber,
          first_name: _event.cart?.ShippingAddress?.FirstName,
          last_name: _event.cart?.ShippingAddress?.LastName,
          address1: _event.cart?.ShippingAddress?.Address1,
          address2: _event.cart?.ShippingAddress?.Address2,
          city: _event.cart?.ShippingAddress?.City,
          countryCode: _event.cart?.ShippingAddress?.CountryCode,
          provinceCode: _event.cart?.ShippingAddress?.ProvinceCode,
          zip: _event.cart?.ShippingAddress?.Zip,
          orderId: _event.cart?.ID,
          currency: _event.cart?.currencyCode || 'USD',
          value: _event.cart?.TotalAmount,
          payment_type: _event.paymentType,
          id: _event.eventId,
          url: window.location.href,
          shipping: _event.cart?.Fees,
          items: mapItems(),
        });
      }

      console.log(`GTM custom event sent for GTM ID: ${gtmID}`);
      console.log(window.dataLayer, 'dataLayer');
    });
  }
}
